import GoogleChartContainer from "../../components/charts/googleChart";

const GoogleChart = () => {
  return <GoogleChartContainer />;
};

export default GoogleChart;
